// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"style_scrollbar__lBIC_","card":"style_card___G1Xi","mainTab":"style_mainTab__LMVs9"};